import Image from '../Image';

const InclinedCartIcon = () => {
  return (
    <Image
      src={'/marketplace-static/images/icons/inclinedCartIcon.svg'}
      layout="fixed"
      width={31}
      height={31}
      alt={'inclined cart icon'}
    />
  );
};

export default InclinedCartIcon;
